// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error{display:-webkit-box;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-direction:column;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;color:red;margin-bottom:2%}.error-message{width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin-bottom:5%;text-align:center;color:red}", ""]);
// Exports
module.exports = exports;
